import * as MutationTypes from './mutationTypes';
import { LinkTree } from './models';
import * as api from './api';

export const linkTreeListRequest = async ({ commit }, pointOfSaleGuid) => {
  const response = await api.linkTreeListRequest(pointOfSaleGuid);
  const recommendationList = LinkTree.toInstanceList(response.data);
  commit(MutationTypes.LINK_TREE_LIST_SUCCESS, recommendationList);
};

export const deleteLinkTree = async ({ commit }, linkTree) => {
  await api.deleteLinkTreeRequest(linkTree.guid);
  commit(MutationTypes.DELETE_LINK_TREE_SUCCESS, linkTree);
  return linkTree;
};

export const createLinkTree = async ({ commit }, linkTree) => {
  const response = await api.createLinkTreeRequest(linkTree.serialize());
  // Check 409
  const newLinkTree = LinkTree.toInstance(response.data);
  commit(MutationTypes.CREATE_LINK_TREE_SUCCESS, newLinkTree);
  return newLinkTree;
};

export const editLinkTree = async ({ commit }, linkTree) => {
  const response = await api.editLinkTreeRequest(linkTree.guid, linkTree.serialize());
  // Check 409
  const editedLinkTree = LinkTree.toInstance(response.data);
  commit(MutationTypes.EDIT_LINK_TREE_SUCCESS, editedLinkTree);
  return editedLinkTree;
};
